import { ConsultantsQueryRadiographerInput, SelectType } from "@graphql";

export const radiographerInitialValues: ConsultantsQueryRadiographerInput = {
  experience: {
    type: SelectType.ANY,
    value: []
  },
  machines: {
    type: SelectType.ANY,
    value: []
  }
};
